import { ICellRendererParams } from 'ag-grid-enterprise';

export enum IconType {
    Chat,
    Voice,
    Email,
    IVR,
    SMS,
    Facebook_Messenger,
    Twitter_Direct_Message,
    WhatsApp,
    Apple_Business_Chat,
    LINE_Messaging,
    Telegram_Messenger,
    Viber_Messenger,
    Custom,
    WorkItem,
    Google_Business_Messenger,
    Slack,
    Microsoft_Teams,
    Facebook_Public,
    LinkedIn_Public,
    Twitter_Public,
    YouTube_Public,
    Apple_Apps_Reviews_Public,
    Google_Places_Public,
    Google_Play_Public,
    Custom_Public,
    Desktop_Activity
}

export const IconMap = {
	[IconType.Chat]: '../App_Themes/CXone/icons/widget-chat.svg#widget-chat',
	[IconType.Voice]: '../App_Themes/CXone/icons/widget-call.svg#widget-call',
	[IconType.Email]: '../App_Themes/CXone/icons/social/email.svg#email',
	[IconType.SMS]: '../App_Themes/CXone/icons/sms.svg#sms',
	[IconType.IVR]: '../App_Themes/CXone/icons/widget-call.svg#widget-call',
	[IconType.Facebook_Messenger]: '../App_Themes/CXone/icons/social/fb-messenger.svg#fb-messenger',
	[IconType.Twitter_Direct_Message]: '../App_Themes/CXone/icons/social/twitter.svg#twitter',
	[IconType.WhatsApp]: '../App_Themes/CXone/icons/social/whats-app.svg#whats-app',
	[IconType.Apple_Business_Chat]: '../App_Themes/CXone/icons/social/apple.svg#apple',
	[IconType.LINE_Messaging]: '../App_Themes/CXone/icons/social/line.svg#line',
	[IconType.Telegram_Messenger]: '../App_Themes/CXone/icons/social/telegram.svg#telegram',
	[IconType.Viber_Messenger]: '../App_Themes/CXone/icons/social/viber.svg#viber',
	[IconType.Custom]: '../App_Themes/CXone/icons/custom-channel.svg#custom-channel',
	[IconType.WorkItem]: '../App_Themes/CXone/icons/workitem.svg#workitem',
	[IconType.Google_Business_Messenger]: '../App_Themes/CXone/icons/social/google-business-messenger.svg#google-business-messenger',
	[IconType.Slack]: '../App_Themes/CXone/icons/social/slack.svg#slack',
	[IconType.Microsoft_Teams]: '../App_Themes/CXone/icons/social/teams-msg.svg#teams-msg',
	[IconType.Facebook_Public]: '../App_Themes/CXone/icons/social/fb-messenger.svg#fb-messenger',
	[IconType.Twitter_Public]: '../App_Themes/CXone/icons/social/twitter.svg#twitter',
	[IconType.YouTube_Public]: '../App_Themes/CXone/icons/social/youtube.svg#youtube',
	[IconType.LinkedIn_Public]: '../App_Themes/CXone/icons/social/linkedin.svg#linkedin',
	[IconType.Apple_Apps_Reviews_Public]: '../App_Themes/CXone/icons/social/apple.svg#apple',
	[IconType.Google_Places_Public]: '../App_Themes/CXone/icons/social/google-business-messenger.svg#google-business-messenger',
	[IconType.Google_Play_Public]: '../App_Themes/CXone/icons/social/google-business-messenger.svg#google-business-messenger',
	[IconType.Custom_Public]: '../App_Themes/CXone/icons/custom-channel.svg#custom-channel'
};

export interface IconDetail {
    iconType: IconType;
}

export interface ChannelTypeCellRendererParams extends ICellRendererParams {
    iconPath?: (data) => IconDetail;
}